<template>
  <div class="card pl-4 pr-4 pb-4 pt-4 mt-4 mt-md-2" v-if="totalEditorPage">
    <div class="card-header border-0 pl-2 pt-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Editor Info</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="editors">
        <template slot="columns">
          <th>Profile</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          <th>Edit</th>
          <th>Delete</th>
        </template>

        <template slot-scope="{row}">
          <td class="td-profile">
            <span class="avatar avatar-sm rounded-circle">
              <img
                :src="row.profile ? row.profile : require('@/assets/default_profile_picture.png')"
              />
            </span>
          </td>
          <td>{{row.firstName}}</td>
          <td>{{row.lastName}}</td>
          <td>{{row.email}}</td>
          <td class="pl-1">
            <button class="btn btn-info" @click="onEditClicked(row.id)">
              <img src="@/assets/icons/ic_edit.svg" /> Edit
            </button>
          </td>
          <td class="pl-1">
            <button
              class="btn"
              :class="{'btn-success': row.status === 'disabled', 'btn-delete': row.status === 'active' }"
              @click="onActiveClicked(row)"
            >
              <!-- <img src="@/assets/icons/ic_delete.svg" v-if="row.status === 'active'" /> -->
              {{ row.status === 'active' ? 'Deactive' : 'Active'}}
            </button>
          </td>
        </template>
      </base-table>
      <div class="card-footer d-flex justify-content-center">
        <base-pagination :page-count="totalEditorPage" v-model="pagination" @input="onPageChanged"></base-pagination>
      </div>
      <confirmation-modal
        type="danger"
        :isLoading="isLoading"
        :showModal.sync="showModal"
        message="Are you sure want to Deactive this Editor?"
        positiveText="Deactive"
        negativeText="Cancel"
        @onPositiveClicked="onPositiveClicked()"
        @onNegativeClicked="onNegativeClicked()"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { GET_USERS, UPDATE_USER_STATUS } from '@/store/actions.type'

export default {
  name: 'editor-info-table',
  data() {
    return {
      selectedEditor: null,
      pagination: 1,
      showModal: false
    }
  },
  created() {
    this.$store.dispatch(GET_USERS, {
      role: 'content_editor',
      page: this.pagination
    })
  },
  methods: {
    onEditClicked(id) {
      this.$router.push({ path: `user/${id}` })
    },
    onActiveClicked(editor) {
      this.selectedEditor = editor
      if (editor.status === 'active') {
        this.showModal = true
      } else {
        this.updateStatus('active')
      }
    },
    onPageChanged(page) {
      this.$store.dispatch(GET_USERS, {
        role: 'content_editor',
        page
      })
    },
    onPositiveClicked() {
      this.updateStatus('disabled')
    },
    onNegativeClicked() {
      this.showModal = false
    },
    updateStatus(status) {
      this.$store
        .dispatch(UPDATE_USER_STATUS, {
          id: this.selectedEditor.id,
          status: status
        })
        .then(() => {
          this.showModal = false
          this.selectedEditor.status = status
        })
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.user.isLoading,
      totalEditorPage: state => state.user.totalEditorPage,
      editors: state => state.user.editors,
      error: state => state.user.errror
    })
  }
}
</script>

<style scoped>
.btn-info {
  padding: 0.45rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
}
.btn-delete {
  padding: 0.45rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
  background-color: #f65858;
}
.btn-delete:hover {
  background-color: #f65858;
}
.btn-success {
  padding: 0.45rem 1.2rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}
.btn-cancel {
  border-color: #f65858 !important;
  color: #f65858 !important;
}
.btn-cancel:hover {
  background-color: transparent !important;
}
.default-button {
  padding: 0.625rem 1.25rem !important;
  font-size: 0.875em !important;
}
</style>
